import { render, staticRenderFns } from "./UploadPolicy.vue?vue&type=template&id=247e0bb8&"
import script from "./UploadPolicy.vue?vue&type=script&lang=js&"
export * from "./UploadPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports